<template lang="pug">
div.w-full
  div(:class="$style.panelContainer")
    TrustPilotWidget(class="hidden md:flex lg:hidden" :stacked="true")
    div(v-show="headerCopy && headerCopy.number_of_quotes_in_area" class="md:hidden rounded-lg bg-gray-100 p-ds-xxs")
      p.m-0.text-center.text-rebrandXs.text-gray-800
        span.mr-ds-sm 🤩
        span {{$t('go_local.cta.intro')}} {{ (headerCopy || {}).number_of_quotes_in_area }} {{ peopleOrPerson(headerCopy) }} {{$t('go_local.cta.outro')}}
    Btn(
      class="min-w-0 bg-anyvan-cta-primary text-white text-rebrandSm justify-center"
      @click="submitForm"
      :disabled="formSubmitted"
      size="xl"
      kind="rebrand-cta"
      :block="true"
      :loading="quoteDataLoading || formSubmitted"
      :to="getButtonHref"
      btn-with-padding
      target="_self") {{ getButtonText }}
    a.hidden(:href="getButtonHref" id="continue-quote-link")
    div(class="hidden lg:block min-w-0")
      Btn(
        v-show="getPhoneNumberValue.formatted"
        :class="[$style.phoneButton, 'ml-0 text-black70 border border-black20 hover:bg-black10']"
        @click="handleCallUsClick()"
        size="xl"
        kind="rebrand-cta"
        :block="true"
        btn-with-padding)
        span.flex.justify-center.gap-ds-sm.items-center(v-show="getPhoneNumberValue.formatted")
          Icon(
            :size="24"
            name="i:telephone-circle-1"
          )
          span.text-rebrandSm {{ getPhoneNumberValue.formatted }}
    div(class="lg:hidden min-w-0")
      Btn(
        :class="[$style.phoneButton, 'ml-0 text-black70 border border-black20 hover:bg-black10']"
        @click="handleCallUsClick()"
        size="xl"
        kind="cta-secondary"
        :block="true"
        btn-with-padding)
        span.flex.justify-center.gap-ds-sm.items-center(v-show="getPhoneNumberValue.formatted")
          Icon(
            :size="24"
            name="i:telephone-circle-1"
          )
          span.text-rebrandSm {{ getPhoneNumberValue.formatted }}
    TrustPilotWidget(class="flex justify-center md:hidden" :stacked="false")
  div(class="hidden lg:flex w-full justify-center mt-ds-ml")
    TrustPilotWidget(:stacked="false")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { GET_PHONE_NUMBER_VALUE } from "~/store/phone-number"
import { extractHref, getInnerText, matchProtocolAndHost } from "~/scripts/useful-functions"
import {
  GET_BOOKING_QUOTE,
  GET_BOOKING_QUOTE_LOADING,
  GET_BOOKINGS_COPY
} from "~/store/booking-insights"

export default defineComponent({
  name: "PanelCTAs",
  props: {
    block: {
      type: Object as () => Block,
      required: true
    }
  },
  data() {
    return {
      formSubmitted: false
    }
  },
  computed: {
    ...mapGetters("phone-number", {
      getPhoneNumberValue: GET_PHONE_NUMBER_VALUE
    }),
    ...mapGetters("booking-insights", {
      headerCopy: GET_BOOKINGS_COPY,
      quoteData: GET_BOOKING_QUOTE,
      quoteDataLoading: GET_BOOKING_QUOTE_LOADING
    }),
    getButtonHref(): string {
      if (this.quoteData?.continueQuoteUrl) return this.quoteData.continueQuoteUrl
      const button = this.block.innerBlocks[0]
      const href = extractHref(button.innerBlocks[0]?.innerHtml) || ""
      return href.replace(matchProtocolAndHost, this.$config.public.v4Host)
    },
    getButtonText(): string {
      if (this.quoteDataLoading) return this.$t("go_local.cta.loading")
      if (this.quoteData?.continueQuoteUrl) return this.$t("go_local.cta.continue")
      const button = this.block.innerBlocks[0]
      return getInnerText(button.innerBlocks[0]?.innerHtml)
    }
  },
  methods: {
    submitForm() {
      this.$emit("submit-form")
    },
    handleCallUsClick() {
      this.$snowplow.trackCallUs({
        phoneNumber: this.getPhoneNumberValue.baseRaw,
        label: "panel_cta_button",
        action: "click",
        extension: this.getPhoneNumberValue.extension
      })
      window.location.href = `tel:${this.getPhoneNumberValue.base}`
    },
    peopleOrPerson(headerCopy: AvBookingsCopy): string {
      if (!headerCopy || !headerCopy.number_of_quotes_in_area) return ""
      return headerCopy.number_of_quotes_in_area === 1
        ? this.$t("go_local.person")
        : this.$t("go_local.people")
    }
  }
})
</script>

<style module lang="css">
.panelContainer {
  @apply flex flex-col md:grid lg:items-center gap-ds-md;

  @screen md {
    grid-template-columns: 200px 1fr 1fr;
  }

  @screen lg {
    grid-template-columns: 1fr 1fr;
  }
}
.phoneButton {
  margin-left: 0 !important; /* Overrides pesky margin in Btn component */
}
</style>
